import * as channelsRoutines from './channelRoutines';
const initialState = {
    messages: {},
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case channelsRoutines.clearChannelMessagesData.TRIGGER:
            return {
                ...state,
                messages: {},
            };

        case channelsRoutines.syncChannelMessages.SUCCESS:
            return {
                ...state,
                messages: action.payload,
            };

        default:
            return state;
    }
}
